import React, { useState, useEffect } from "react";
import Select from "react-select";
import { ServiceCenterAPI } from "../../services";

/**
 * Select de departamentos
 */
const DepartmentSelect = ({
  value,
  onChange,
  label,
  placeholder = "Selecione um departamento...",
  isDisabled = false,
  isClearable = true,
  className = "",
}) => {
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadDepartments = async () => {
      setIsLoading(true);
      try {
        const response = await ServiceCenterAPI.getDepartments();
        const list = Array.isArray(response)
          ? response
          : response.results || response || [];
        setDepartments(list);
      } catch (error) {
        console.error("Erro ao carregar departamentos:", error);
        setDepartments([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadDepartments();
  }, []);

  const options = departments.map((dept) => ({
    value: dept.id,
    label: dept.name,
    description: dept.description,
    usersCount: dept.users_count,
  }));

  // Suporta tanto value direto (número) quanto objeto {value, label}
  const selectedOption = options.find((opt) =>
    opt.value === value || opt.value === value?.value
  ) || null;

  const formatOptionLabel = (option) => (
    <div className="sc-department-option">
      <div className="sc-department-option__name">
        🏢 {option.label}
      </div>
      {option.usersCount !== undefined && (
        <div className="sc-department-option__users">
          👥 {option.usersCount} {option.usersCount === 1 ? "usuário" : "usuários"}
        </div>
      )}
    </div>
  );

  const customStyles = {
    option: (provided) => ({
      ...provided,
      padding: "10px 12px",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "42px",
    }),
  };

  return (
    <div className={`sc-department-select ${className}`}>
      {label && <label className="sc-department-select__label">{label}</label>}
      <Select
        value={selectedOption}
        onChange={(option) => onChange(option || null)}
        options={options}
        placeholder={placeholder}
        isLoading={isLoading}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable
        formatOptionLabel={formatOptionLabel}
        styles={customStyles}
        noOptionsMessage={() => "Nenhum departamento encontrado"}
        loadingMessage={() => "Carregando..."}
      />
    </div>
  );
};

export default DepartmentSelect;
